import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useWorklistTheme } from '../../../hooks/useWorklistTheme';

/**
 * Light or dark worklist: labellers who spend hours in the dark viewer can keep the rest dark too. Drawn for
 * the header's DeepHealth plum bar.
 */
export function ThemeToggle() {
  const [theme, toggle] = useWorklistTheme();
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={
        dark ? 'Switch to the light theme' : 'Switch to the dark theme'
      }
      title={dark ? 'Light theme' : 'Dark theme'}
      className="flex h-10 w-10 items-center justify-center rounded-lg text-white/80 transition hover:bg-white/10 hover:text-white"
    >
      {dark ? (
        <SunIcon className="h-5 w-5" />
      ) : (
        <MoonIcon className="h-5 w-5" />
      )}
    </button>
  );
}
